export default __webpack_public_path__ + "static/media/avatar.ad890a91.svg";